import { render, staticRenderFns } from "./footer-tabs.vue?vue&type=template&id=10fa7fc1&"
import script from "./footer-tabs.vue?vue&type=script&lang=js&"
export * from "./footer-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports